(($, drupalSettings) => {
    const video = document.querySelector('.front [data-highlight-video]') || null;
    const go = video ? video.querySelector('video') || null : '';

    	/**
	 * Vidéo interne autoplay
	 */
	const videoAutoplay = () => {
		go ? (go.muted = true) && (go.autoplay = true) : '';
	};

	const fctPlay = () => {
		const playPromise = go ? go.play() : '';

		if (playPromise !== undefined) {
			playPromise.then(() => {}).catch((err) => {});
		}
	};

	/**
	 * Vidéo Youtube autoplay
	 */
	const medias = drupalSettings.media || null;
	const media = medias
		? Object.values(medias).filter((media) => media.type === `video`)[0]
		: '';
    const videoContainer = video && video.querySelector('.video');

    let iframeAutoplay = '';

    const addAutoplay = () => {
        iframeAutoplay = media.iframe.slice(0, media.iframe.indexOf('" allow="')) + "&autoplay=1&mute=1" + media.iframe.slice(media.iframe.indexOf('" allow="'));
        return iframeAutoplay;
    }

    const loadVideo = () => {
		if(videoContainer) {
			if(videoContainer.classList.contains('not_allowed')) {
				videoContainer.classList.remove('not_allowed');
			}
			videoContainer.innerHTML = addAutoplay();
		}
    }

    	// GO 🚀
	const init = () => {
		video ? videoAutoplay() && fctPlay() : '';
	};

	init();

    if (video) {
		$(document).ready(function () {
            if (document.cookie.indexOf('youtube=true') > -1) {
                loadVideo();
            } else {
				videoContainer.classList.add('not_allowed');
				videoContainer.innerHTML = `<p> ${
					media.provider.charAt(0).toUpperCase() + media.provider.slice(1)
				} est désactivé </p>
                                <button class="allow__cookie" data-allow-cookie= "${media.provider}">${
					ModuloTS.Allow
				}</button>`;
			}

            waitForElm('.video [data-allow-cookie]').then(() => {
                const allowButtons =
                    document.querySelectorAll('.video [data-allow-cookie]') || null;
    
                if (allowButtons) {
                    allowButtons.forEach((el) => {
                        el.addEventListener('click', () => loadVideo());
                    });
                }
            });
		});
	}
})(jQuery, drupalSettings);